import React from "react";
import { useColorModeValue } from "../components/ui/color-mode";
import { Grid, Stack, Flex, Image, Text } from "@chakra-ui/react";
import RichText from "../components/custom/RichText";
import { FaAmazonPay } from "react-icons/fa";
import CustomCard from "../components/custom/CustomCard";
import { Helmet } from "react-helmet-async";

const PaymentScreen = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");

  const features = [
    {
      icon: "../assets/affordable.png",
      title: "Affordable Pricing",
      tagline: "Transparent and Competitive Rates with No Hidden Fees",
    },
    {
      icon: "../assets/trusted.png",
      title: "Secure Transactions",
      tagline: "End-to-end encrypted payments for complete security",
    },
    {
      icon: "../assets/quick.png",
      title: "Quick & Easy Process",
      tagline: "Complete your payment in just a few clicks",
    },
    {
      icon: "../assets/data.png",
      title: "Data Security",
      tagline: "Your Privacy and Data Security Are Our Top Priority",
    },
  ];

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>Secure Payment Options - 360fintax</title>
        <meta
          name="description"
          content="Make secure payments for 360fintax services. We offer multiple payment methods to ensure a convenient and safe transaction experience."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/payments"
        />
      </Helmet>

      {/* Hero Section */}
      <Stack
        bgColor={secondBg}
        justifyContent="center"
        alignItems="center"
        py="20"
        px={{ base: "10", md: "40", lg: "40" }}
        gap="20"
      >
        <Grid
          templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }}
          gap={{ base: "10", md: "20", lg: "0" }}
          justifyItems="center"
          pt={{ base: "10", md: "10", lg: "10" }}
          alignItems="center"
        >
          {/* 1st Grid Item */}
          <Stack gap={6}>
            <RichText
              title="Experience the benefits of "
              colorText="360fintax"
              textAlign="left"
            />
            <Grid templateColumns="repeat(1, 1fr)" gap="5" px="2">
              {features.map((feature) => (
                <Flex
                  key={feature.title}
                  gap={5}
                  direction={{ base: "row", md: "row" }}
                  alignItems={{ base: "start", md: "start" }}
                >
                  <Image src={feature.icon} boxSize="12" loading="eager" />
                  <Stack textAlign={{ base: "center", md: "left" }}>
                    <Text
                      fontSize={{ base: "md", md: "xl" }}
                      fontWeight="semibold"
                    >
                      {feature.title}
                    </Text>
                    <Text
                      fontSize={{ base: "sm", md: "md" }}
                      color="gray.500"
                      display={{ base: "none", md: "block" }}
                    >
                      {feature.tagline}
                    </Text>
                  </Stack>
                </Flex>
              ))}
            </Grid>
          </Stack>

          {/* 2nd Grid Item */}
          <CustomCard
            src="../assets/tax3d.png"
            boxSize={100}
            title="Make a Secure Payment with Confidence"
            description="360fintax ensures a smooth and secure payment process. Whether you're paying for tax services, financial consultations, or other transactions, rest assured your payment is safe. Choose your preferred method and complete your payment in seconds."
            button2="Pay Now"
            lineClamp="none"
            backgroundColor2="#008080"
            url2="https://razorpay.me/@360fintax"
            icon2={null}
          />
        </Grid>
      </Stack>
    </>
  );
};

export default PaymentScreen;
